import { getCurrentHub } from '@sentry/nextjs';
import AdsGeneratorMemo from '@/components/Ads/Google/AdsTypeGeneratorsMemo';
import NewsLetter from '../Widgets/NewsLetter/NewsLetter';

interface SideContentProps {
  placeholderAds?: boolean;
  shouldRenderAds?: boolean;
  enableNewsLetter?: boolean;
}

export default function SideContent({ shouldRenderAds = true, placeholderAds = false, enableNewsLetter = false }: SideContentProps) {
  const transaction = getCurrentHub().getScope()?.getTransaction();
  const sideContentSpan = transaction && transaction.startChild({ op: 'sideContent' });

  return (
    <div className="z-[2] h-full w-full self-start tablet:w-[336px]">
      <div className="sticky top-2">
        {shouldRenderAds && <AdsGeneratorMemo isPlaceholder={placeholderAds} type="halfpage" />}
        {enableNewsLetter && <NewsLetter />}
      </div>
      {sideContentSpan && sideContentSpan.finish()}
    </div>
  );
}
